"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _defineProperty = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.array.index-of");

var _objectWithoutProperties = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardMedia = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _components = require("./components");

var _core = require("@emotion/core");

var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  component: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]),
  image: _propTypes.string,
  src: _propTypes.string,
  style: _propTypes.object,
  ref: _propTypes.object
} : {};

var CardMedia = function CardMedia(_ref) {
  var className = _ref.className,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'div' : _ref$component,
      image = _ref.image,
      src = _ref.src,
      style = _ref.style,
      ref = _ref.ref,
      other = _objectWithoutProperties(_ref, ["className", "component", "image", "src", "style", "ref"]);

  var UsedComponent = _components.CardMediaStyled.withComponent(Component, {
    target: "e18mq5os0"
  });

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? _objectSpread({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return (0, _core.jsx)(UsedComponent, (0, _extends2["default"])({
    css: _stylitas.cardMediaBase,
    className: className,
    ref: ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined,
    isMedia: isMediaComponent
  }, other));
};

exports.CardMedia = CardMedia;
process.env.NODE_ENV !== "production" ? CardMedia.propTypes = propTypes : void 0;